// Central content store. Currently German only.
// Structure prepared for future language toggle (e.g. add `hu` alongside `de`).

export const LANGS = ["de"]; // future: ["de", "hu"]
export const DEFAULT_LANG = "de";

export const t = {
  de: {
    brand: "CLEANSORA",
    slogan: "Gebäude- & Solarreinigung",
    nav: {
      home: "Start",
      about: "Über uns",
      services: "Leistungen",
      process: "Ablauf",
      contact: "Kontakt",
      soon: "Bald verfügbar",
      software: "Software",
      portal: "Kundenportal",
      app: "Mitarbeiter-App",
      quote: "Kostenloses Angebot",
    },
    hero: {
      overline: "Premium Gebäude- & Solarreinigung",
      headline: ["Professionelle Reinigung,", "der Unternehmen", "vertrauen können."],
      sub: "Zuverlässige, hochwertige und umweltbewusste Reinigungslösungen, individuell abgestimmt auf Ihr Unternehmen.",
      cta1: "Kostenloses Angebot",
      cta2: "Kontakt aufnehmen",
      scroll: "Entdecken",
    },
    marquee: ["Büroreinigung", "Solarreinigung", "Gebäudereinigung", "Praxisreinigung", "Glasreinigung", "Industriereinigung", "Hausmeisterservice", "Treppenhausreinigung"],
    about: {
      overline: "Über CLEANSORA",
      title: "Sauberkeit als Ausdruck von Professionalität.",
      lead: "CLEANSORA steht für makellose Ergebnisse, moderne Technik und echte Partnerschaft. Wir behandeln jedes Gebäude, als wäre es unser eigenes.",
      values: [
        { n: "01", t: "Zuverlässigkeit", d: "Termine, die halten. Ergebnisse, auf die Sie sich verlassen können." },
        { n: "02", t: "Professionalität", d: "Geschultes Personal mit höchstem Anspruch an jede Aufgabe." },
        { n: "03", t: "Höchste Qualität", d: "Wir liefern Ergebnisse, die man sieht – bis ins Detail." },
        { n: "04", t: "Kundenzufriedenheit", d: "Ihr Feedback ist der Maßstab für unsere Arbeit." },
        { n: "05", t: "Langfristige Partnerschaften", d: "Wir denken in Beziehungen, nicht in Einzelaufträgen." },
        { n: "06", t: "Moderne Ausrüstung", d: "Neueste Technik für effiziente und schonende Reinigung." },
        { n: "07", t: "Geschultes Personal", d: "Regelmäßige Schulungen für konstante Spitzenqualität." },
        { n: "08", t: "Transparente Kommunikation", d: "Klar, ehrlich und jederzeit erreichbar." },
      ],
    },
    servicesSection: {
      overline: "Unsere Leistungen",
      title: "Ein Partner für jede Reinigungsaufgabe.",
      learn: "Mehr erfahren",
    },
    why: {
      overline: "Warum CLEANSORA",
      title: "Der Unterschied liegt im Anspruch.",
      items: [
        "Erfahrene Fachkräfte",
        "Zuverlässiger Service",
        "Umweltfreundliche Reinigung",
        "Flexible Terminplanung",
        "Transparente Preise",
        "Moderne Ausrüstung",
        "Vollständig versichert",
        "Herausragender Kundenservice",
      ],
    },
    process: {
      overline: "Unser Ablauf",
      title: "In fünf klaren Schritten zur perfekten Sauberkeit.",
      steps: [
        { t: "Kontakt aufnehmen", d: "Schreiben oder rufen Sie uns an – unkompliziert und schnell." },
        { t: "Kostenlose Beratung", d: "Wir analysieren Ihren Bedarf persönlich und individuell." },
        { t: "Individuelles Angebot", d: "Transparent, fair und exakt auf Sie zugeschnitten." },
        { t: "Professionelle Reinigung", d: "Unser geschultes Team liefert makellose Ergebnisse." },
        { t: "Laufende Qualitätskontrolle", d: "Wir bleiben dran und sichern konstante Qualität." },
      ],
    },
    stats: {
      overline: "In Zahlen",
      title: "Anspruch, der sich messen lässt.",
      items: [
        { v: "100%", l: "Kundenzufriedenheit" },
        { v: "Professionell", l: "Reinigungstechnik" },
        { v: "Zuverlässig", l: "Reinigungsexperten" },
        { v: "Flexibel", l: "Terminplanung" },
      ],
    },
    area: {
      overline: "Einsatzgebiet",
      title: "Für Sie in der Region im Einsatz.",
      lead: "Wir sind in Kitzingen, Würzburg, Bamberg und Umgebung für Sie da – im Umkreis von etwa 50 km um Ebrach.",
      cities: ["Kitzingen", "Würzburg", "Bamberg", "Umkreis ~50 km um Ebrach"],
      note: "Ihr Standort ist nicht dabei? Sprechen Sie uns gerne an – wir finden eine Lösung.",
    },
    cta: {
      title: "Bereit für einen saubereren Arbeitsplatz?",
      text: "Fordern Sie noch heute Ihr kostenloses Angebot an und überlassen Sie CLEANSORA die Reinigung Ihres Unternehmens.",
      btn: "Kostenloses Angebot anfordern",
    },
    contact: {
      overline: "Kontakt",
      title: "Lassen Sie uns über Ihr Projekt sprechen.",
      lead: "Füllen Sie das Formular aus – wir melden uns in der Regel telefonisch bei Ihnen.",
      form: {
        name: "Name",
        company: "Unternehmen",
        email: "E-Mail",
        phone: "Telefon",
        service: "Gewünschte Leistung",
        message: "Ihre Nachricht",
        submit: "Anfrage senden",
        sending: "Wird gesendet …",
        optional: "optional",
        success: "Vielen Dank für Ihre Anfrage. Wir haben Ihre Nachricht erhalten und werden uns schnellstmöglich bei Ihnen melden.",
        error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      },
      info: {
        phoneLabel: "Telefon",
        phone: "+49 157 56563031",
        emailLabel: "E-Mail",
        email: "info@cleansora.de",
        hoursLabel: "Geschäftszeiten",
        hours: ["Mo – Fr: 08:00 – 18:00 Uhr", "Sa: nach Vereinbarung", "So: geschlossen"],
      },
    },
    soon: {
      badge: "Bald verfügbar",
      text: "CLEANSORA entwickelt eine eigene Management-Software für Reinigungsunternehmen. Dieser Bereich befindet sich derzeit im Aufbau.",
      back: "Zurück zur Startseite",
      software: { title: "CLEANSORA Software", d: "Die komplette Management-Plattform für moderne Reinigungsunternehmen." },
      portal: { title: "Kundenportal", d: "Aufträge, Angebote und Berichte – alles an einem Ort für unsere Kunden." },
      app: { title: "Mitarbeiter-App", d: "Einsatzpläne, Aufgaben und Kommunikation direkt für unser Team." },
    },
    footer: {
      tagline: "Premium Gebäude- & Solarreinigung für Unternehmen, die Wert auf Qualität legen.",
      col1: "Navigation",
      col2: "Rechtliches",
      col3: "Kontakt",
      privacy: "Datenschutz",
      legal: "Impressum",
      rights: "Alle Rechte vorbehalten.",
      follow: "Folgen Sie uns",
    },
    legal: {
      privacyTitle: "Datenschutzerklärung",
      legalTitle: "Impressum",
      placeholder: "Dieser Inhalt ist ein Platzhalter und kann jederzeit angepasst werden.",
    },
  },
};
